import { z } from 'zod';
import { TimestampSchema, UuidSchema } from './common';

/**
 * LGPD audit log — operações sensíveis (export, delete, opt-out de leads;
 * login_success/logout/session_revoke de users). Append-only no DB,
 * read-only via API.
 */

export const LgpdAuditActionSchema = z.enum([
  'export',
  'delete',
  'opt_out',
  'login_success',
  'login_fail',
  'logout',
  'session_revoke',
  // Eventos de reset de senha — gravados por auditPasswordResetEvent. Sem
  // estes, a rota /lgpd/audit-log rejeita a resposta (500) ao paginar
  // histórico que contenha um reset.
  'password_reset_request',
  'password_reset_confirm',
]);
export type LgpdAuditAction = z.infer<typeof LgpdAuditActionSchema>;

export const LgpdAuditSubjectTypeSchema = z.enum([
  'lead',
  'connection',
  'integration',
  'user',
  'session',
]);
export type LgpdAuditSubjectType = z.infer<typeof LgpdAuditSubjectTypeSchema>;

export const LgpdAuditActorTypeSchema = z.enum(['operator', 'system']);
export type LgpdAuditActorType = z.infer<typeof LgpdAuditActorTypeSchema>;

export const LgpdAuditLogEntrySchema = z.object({
  id: UuidSchema,
  tenantId: UuidSchema,
  action: LgpdAuditActionSchema,
  subjectType: LgpdAuditSubjectTypeSchema,
  subjectId: UuidSchema,
  subjectIdentifier: z.string(),
  reason: z.string().nullable(),
  actor: LgpdAuditActorTypeSchema,
  performedAt: TimestampSchema,
});
export type LgpdAuditLogEntry = z.infer<typeof LgpdAuditLogEntrySchema>;

export const LgpdAuditLogQuerySchema = z.object({
  action: LgpdAuditActionSchema.optional(),
  subjectType: LgpdAuditSubjectTypeSchema.optional(),
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(100).optional(),
});
export type LgpdAuditLogQuery = z.infer<typeof LgpdAuditLogQuerySchema>;

export const LgpdAuditLogListResponseSchema = z.object({
  entries: z.array(LgpdAuditLogEntrySchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
});
export type LgpdAuditLogListResponse = z.infer<typeof LgpdAuditLogListResponseSchema>;
